import { render, staticRenderFns } from "./checkTranBoxes.vue?vue&type=template&id=5af808c7&scoped=true&"
import script from "./checkTranBoxes.vue?vue&type=script&lang=js&"
export * from "./checkTranBoxes.vue?vue&type=script&lang=js&"
import style0 from "./checkTranBoxes.vue?vue&type=style&index=0&id=5af808c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af808c7",
  null
  
)

component.options.__file = "checkTranBoxes.vue"
export default component.exports